<script>
import lazyLoadComponent from '@router/lazyload-component'
import { pickObjectByKey } from '@utils'
import { authComputed } from '@state/helpers'

import { productStateMap, productStateFilter } from '@utils/filter-value-to-text'

const stateButtonMap = (productType) => {
  return {
    add: {
      page: 'add',
      icon: 'edit',
      label: '繼續新增步驟',
      actionName: 'editProduct',
    },
    // edit: {
    //   page: 'edit',
    //   icon: 'edit',
    //   label: `編輯${productType}`,
    //   actionName: 'editProduct',
    // },
    //   require('@fortawesome/pro-light-svg-icons/faUserAlt').definition,
    // require('@fortawesome/pro-light-svg-icons/faStoreAltSlash').definition,
    staff: {
      icon: 'user-alt',
      label: `查看人員`,
      actionName: 'searchStaff',
    },
    orders: {
      page: 'orders',
      icon: 'eye',
      label: '查看訂單',
      actionName: 'searchOrder',
    },
    on: {
      function: 'updateState',
      icon: 'eye',
      label: `啟用${productType}`,
      actionName: 'updateProductState',
    },
    off: {
      function: 'updateState',
      icon: 'store-alt-slash',
      label: `下架${productType}`,
      actionName: 'updateProductState',
    },
  }
}
export default {
  components: {
    BaseButton: () => lazyLoadComponent(import('@components/BaseButton')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  filters: {
    productStateFilter,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleA: false,
      clickLabel: '', // 這次點到開窗的label名稱
      staffs: [], // 人員列表
      dialogCalendarVisible: false,
    }
  },
  mounted() {
    this.$emit('ready', this.data.id)
  },
  computed: {
    ...authComputed,
    buttons() {
      const stateButtonArray = productStateMap[this.data.state].buttons
      const result = pickObjectByKey(
        stateButtonMap(this.$t(`${this.data.type}.NAME`)),
        stateButtonArray
      )
      return result
    },
    enabledDeleteButton() {
      return this.data.activeOrders === 0
    },
    productCalendarURL() {
      return `${window.location.origin}/api/${this.currentUser.merchantAlias}/${this.currentUser.merchantId}/product/${this.data.alias}/ical`
    }
  },
  methods: {
    async openStaffWindow() {
      this.staffs = await this.$store.dispatch('schedule/fetchStaff', { paginate: 0})
      this.staffs = this.staffs.filter(item => item.storeTitles.includes(this.data.name))
      this.dialogVisible = true
    },
    emitUpdated() {
      this.$emit('updated')
      this.dialogVisible = false
    },
    handleUpdateState(buttonType) {
      const submitData = {
        ids: [this.data.id],
        state: buttonType === 'off' ? 0 : 1,
      }

      const stateConfirmMap = {
        0: {
          message: this.$t('STATE_OFF_CONFIRM_MESSAGE', {
            name: this.$t(`${this.data.type}.NAME`),
          }),
          confirmText: '立即下架',
        },
        1: {
          message: this.$t('STATE_ON_CONFIRM_MESSAGE', {
            name: this.$t(`${this.data.type}.NAME`),
          }),
          confirmText: '上架分店',
        },
      }
      const confirmContent = stateConfirmMap[submitData.state]

      this.$confirm(confirmContent.message, '提示', {
        confirmButtonText: confirmContent.confirmText,
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.$store.dispatch('product/updateState', submitData).then(() => {
          this.emitUpdated()
        })
      })
    },
    handleRemove() {
      this.$confirm(
        this.$t('DELETE_CONFIRM_MESSAGE', {
          name: this.$t(`${this.data.type}.NAME`),
        }),
        '提示',
        {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
        }
      ).then(() => {
        this.$store.dispatch('product/remove', { ids: [this.data.id] }).then(() => {
          this.emitUpdated()
        })
      })
    },
    handleToPage(buttonType) {
      const typeRouteMap = {
        add: {
          name: 'add-product',
          params: { productId: this.data.id },
          query: {
            type: this.data.type,
          },
        },
        edit: {
          name: 'edit-product',
          params: { productId: this.data.id },
        },
        orders: {
          name: 'orders',
          params: {
            productId: this.data.id,
          },
        },
      }
      this.$router.push(typeRouteMap[buttonType])
    },
    onClickButton(type) {
      switch (type) {
        case 'on':
        case 'off':
          this.handleUpdateState(type)
          break
        case 'calendarUrl':
          this.dialogCalendarVisible = true
          break
        case 'staff':
          this.clickLabel = this.buttons['staff'].label
          this.openStaffWindow()
          break
        default:
          this.handleToPage(type)
          break
      }
    },
    copyCalendarUrl() {
      this.$refs.CalendarUrlInput.select()
      document.execCommand('copy')
      this.$message('連結複製成功')
    },
    openExternal(url) {
      window.open(url, '_blank')
    },
    /**
     * @description icon 前綴字，不然icon顯現不出來
     */
    iconPrefix(type) {
      if (type === 'user-alt' || type === 'store-alt-slash') {
        return 'fal'
      } else {
        return 'far'
      }
    },
    /**
     * @description 下架分店的特殊紅色
     */
    iconStyleColor(type) {
      if (type === 'store-alt-slash') {
        return 'color: red'
      }
    },
    userGroupName(groupArr) {

    },
    gotoStaff(staffItem) {
      this.$router.push({
        name: 'staff',
        params: { userActiveTab: '2', id: staffItem.id },
      })
    }
  },
}
</script>

<template>
  <div :class="[$style.container, { [$style['container--active']]: dialogVisible }]" @click="onClickButton('edit')">
    <div :class="$style.imgAndTitle">
      <el-image :src="data.image" class="image-default spSize" fit="cover">
        <div slot="error" class="image--error">
          <BaseIcon name="image" />
        </div>
      </el-image>
      <div :class="$style.title">
        <h5>{{ data.name }}</h5>
        <p :class="$style.addressType">{{ data.fullAddress }}</p>
        <p :class="$style.phone">{{ data.phone }}</p>
      </div>
    </div>
    <BaseStateLabel :state="data.state | productStateFilter('color')" :class="$style.label" :text-w="true">{{ data.state
        | productStateFilter('text')
    }}</BaseStateLabel>
    <!-- 以下是 編輯分店、下架分店、查看訂單按鈕 -->
    <div style="display:flex;justify-content: space-around;">
      <el-button :class="[$style.buttons, $style.downButtons]"
        v-for="({ icon, label, actionName }, type, index) in buttons" @click.stop="onClickButton(type)">
        <BaseButton :key="type" v-can:api="actionName" spButtonType="productListItem" spColorType="primary"
          :class="$style.buttonList">
          <BaseIcon :name="icon" :iconStyle="iconPrefix(icon)" :style="iconStyleColor(icon)" class="buttonsIcon" />
          <span :style="iconStyleColor(icon)">{{ label }}</span>
        </BaseButton>
        <div v-if="index + 1 !== Object.keys(buttons).length" :class="$style.borderLeft"></div>
      </el-button>
    </div>
    <el-dialog :title="data.name" :visible.sync="dialogVisibleA" top="0" width="300px" append-to-body>
      <div :class="$style.buttons">
        <BaseButton v-for="({ icon, label, actionName }, type) in buttons" :key="type" v-can:api="actionName"
          :icon="icon" @click="onClickButton(type)">{{ label }}</BaseButton>
      </div>
    </el-dialog>
    <el-dialog v-if="dialogVisible" :title="clickLabel" :class="$style.staffList" :visible.sync="dialogVisible" top="0"
      width="550px" append-to-body>
      <div class="eachInfo" v-for="staffItem in staffs" @click="gotoStaff(staffItem)">
        <div :class="[$style.block, { [$style['is-disabled']]: data.block }]">{{ staffItem.block === 0 ? '啟用中' : '停權中'
        }}</div>
        <el-avatar :src="staffItem.avatar" :size="90"></el-avatar>
        <div class="mainInfo">
          <p class="mainName">{{ staffItem.name }}</p>
          <p class="mainRole">{{ staffItem.title }}</p>
          <p class="mainProduct">{{ staffItem.userGroups.map(item => item.title).join(',') }}/{{
              staffItem.storeTitles.join(',')
          }}</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="$t(`${data.type}.NAME`) + '行事曆'" :visible.sync="dialogCalendarVisible"
      :append-to-body="true" top="0" width="680px">
      <el-input ref="CalendarUrlInput" :value="productCalendarURL" :readonly="true">
        <el-button slot="append" @click="copyCalendarUrl">複製此網址</el-button>
      </el-input>
      <p style="margin-top: 50px;">行事曆設定教學</p>
      <div style="margin-bottom: 15px;">
        <el-button style="width: 100%;" type="primary" plain
          @click="openExternal('https://support.apple.com/zh-tw/guide/iphone/iph3d1110d4/ios')">設定於 Apple 行事曆
        </el-button>
      </div>
      <div>
        <el-button style="width: 100%;" type="primary" plain
          @click="openExternal('https://support.google.com/calendar/answer/37100?co=GENIE.Platform%3DDesktop&hl=zh-Hant')">
          設定於 Google 行事曆</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" module>

@mixin borderType {}

.imgAndTitle {
  display: flex;

  .title {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-top: 14px;
    padding-left: 14px;
    border-bottom: 1px solid #E5E7EB;

    >h5 {
      color: $color-primary;
      margin-top: 0px;
      margin-bottom: 4px;
      font-size: 14px;
    }

    >p {
      margin-top: 0px;
      font-size: 12px;
      color: $color-secondary;
    }

    >p.addressType {
      margin-bottom: 14px;
    }
  }
}

.label {
  position: absolute;
  top: 10px;
  left: 0;
}

.container {
  position: relative;
  font-size: $font-size-large;
  cursor: pointer;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E5E7EB;

  &--active .image,
  &:hover .image {
    @include layer-elevation(8);
    border-color: $color-primary;
  }
}

.buttons {
  // width: 432px;
  height: 50px;
  display: flex;
  justify-content: cetner;
  align-items: center;

  >div {
    flex-grow: 1;
  }

  >span {
    color: $color-secondary;
  }

  :global {
    .buttonsIcon {
      color: $color-primary;
      font-size: 14px;
      margin-right: 4px;
    }
  }
}

.downButtons {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin-left: 0 !important;
  position: relative;
  border: none !important;
}

.borderLeft {
  border-left: 1.5px solid #E8EAEE;
  position: absolute;
  right: 0;
  bottom: 25%;
  height: 17px;
}

.staffList {
  padding-left: 45px;
  padding-right: 45px;

  :global {
    .eachInfo {
      padding-left: 40px;
      width: auto;
      height: 145px;
      border: 1px solid $color-line-dark;
      border-radius: $border-radius;
      display: flex;
      align-items: center;
      position: relative;
      margin-bottom: 10px;
      cursor: pointer;
    }

    .el-avatar {
      margin-right: 33px;
    }

    .mainInfo {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      height: 100%;
    }

    .mainName {
      color: $color-primary;
      margin-top: 0;
      margin-bottom: 0;
      font-size: 16px;
    }

    .mainRole {
      color: $color-secondary;
      margin-top: 0;
      margin-bottom: 0;
      font-size: 14px;
    }

    .mainProduct {
      color: $color-text-light;
      margin-top: 0;
      margin-bottom: 0;
      font-size: 12px;
    }
  }
}

.block {
  position: absolute;
  top: 16px;
  right: 0;
  color: white;
  background: #12C494;
  padding: 7px 14px;
  font-size: 12px;

  &.is-disabled {
    background: #e35d5d;
  }
}

// .buttonList {
//   &:not(:last-child) {
//     border-right: 1px solid $color-line;
//   }
// }
</style>
